import { styled } from '@project44/manifest-ds';

import { Panel } from '../Panel';

export const StyledPanel = styled(Panel, {
  '> div': {
    background: '$background-primary',
    zIndex: 1,
  },
});

export const LocationPingsPanel = styled(Panel, {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderLeft: '1px solid $border-primary',
});
